export default __webpack_public_path__ + "static/media/star.f8c3ee66.svg";